import { HelpLinkButton } from 'app/modules/fincenSAR/components/StylingUtils';
import {
  FINTRAC_STR_ACTIVITY_SECTOR_CODES_OPTIONS,
  FINTRAC_STR_MINISTERIAL_DIRECTIVE_CODES_OPTIONS,
} from 'app/modules/fintracStr/formConstants';
import { FintracFormSection } from 'app/modules/fintracStr/models';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const FINTRAC_STR_REPORT_DETAILS_TAB_SECTION: FintracFormSection = {
  type: 'tabSection',
  repeatable: false,
  label: 'Report Details',
  name: 'reportDetails',
  mustExistInPayload: true,
  mustHaveValueIfExist: false,
  fields: [
    [
      {
        type: U21FormFieldTypes.NUMBER,
        name: 'reportingEntityNumber',
        label: 'Reporting entity number',
        required: true,
        mustExistInPayload: true,
        mustHaveValueIfExist: true,
      },
      {
        type: U21FormFieldTypes.NUMBER,
        name: 'reportingEntityContactId',
        label: 'Contact ID of the reporting entity',
        required: true,
        mustExistInPayload: true,
        mustHaveValueIfExist: true,
      },
    ],
    {
      type: U21FormFieldTypes.TEXT,
      name: 'reportingEntityReportReference',
      label: 'Reference number for this report',
      required: true,
      mustExistInPayload: true,
      mustHaveValueIfExist: true,
    },
    [
      {
        type: U21FormFieldTypes.SELECT,
        name: 'activitySectorCode',
        label: 'Activity sector',
        fieldProps: {
          options: FINTRAC_STR_ACTIVITY_SECTOR_CODES_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
      },
      {
        type: U21FormFieldTypes.SELECT,
        name: 'ministerialDirectiveCode',
        label: 'Ministerial directive',
        help: (
          <p>
            You must consider all requirements issued under a Ministerial
            directive along with your suspicious transaction reporting
            requirements. For more information, please refer to the guidance on
            Ministerial directives and transaction restrictions at
            <HelpLinkButton
              href="https://fintrac-canafe.canada.ca/"
              variant="text"
              color="primary"
            >
              FINTRAC&apos;s website
            </HelpLinkButton>
            <br />
            <br />
            If this report is related to a Ministerial Directive, please select
            the corresponding code.
          </p>
        ),
        fieldProps: {
          options: FINTRAC_STR_MINISTERIAL_DIRECTIVE_CODES_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
      },
    ],
  ],
};
